import {Module} from "vuex";
import {RootState} from "../../store";
import LocationsState from "./state";
import actions from './actions';
import getters from './getters'
import mutations from './mutations'


const module: Module<LocationsState, RootState> = {
    state: new LocationsState(),
    actions,
    getters,
    mutations,
}

export default module

